import '.a{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b2{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.b3{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.b4{margin-top:2rem;}.ssr-plugin'
import '.ad{margin-bottom:5rem;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="a f b e b2"
      >
        <DashboardNavBar />
        <div className="b3 a e ae b4 ad b5"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
